import { Component, Input, ElementRef, EventEmitter, Output, OnInit, forwardRef, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { take } from 'rxjs/operators';

import { ApiError, MessageService } from '../../../core';
import { GrupoClassificacao } from '../grupo-classificacao';
import { GrupoClassificacaoFilter } from '../filter/grupo-classificacao-filter';
import { GrupoClassificacaoCrudHttpService } from '../services';
import { grupoClassificacaoSituacaoAtivo, isSituacaoInativo } from '../situacao/grupo-classificacao-situacao';
import { GrupoClassificacaoClassificacao, GrupoClassificacaoClassificacaoHttpService } from '../classificacao';

@Component({
    selector: 'sgt-grupo-classificacao-select',
    templateUrl: './grupo-classificacao-select.component.html',
    styleUrls: ['./grupo-classificacao-select.component.less'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => GrupoClassificacaoSelectComponent), multi: true },
    ]
})
export class GrupoClassificacaoSelectComponent implements OnInit {
    grupos: GrupoClassificacao[];

    /** ID do grupo da classificação */
    @Input() ngModel: number;
    /** Ao alterar o grupo selecionado */
    @Output() ngModelChange = new EventEmitter<number>();

    /** Objeto do grupo */
    @Input() grupoClassificacao: GrupoClassificacao;
    @Output() grupoClassificacaoChange = new EventEmitter<GrupoClassificacao>();

    /** Ao pesquisar as classificações do grupo selecionado */
    @Output() classificacoesChange = new EventEmitter<GrupoClassificacaoClassificacao[]>();

    /**
     * Nome do input decimal
     */
    @Input() name: string;
    /**
     * ID do input decimal
     */
    @Input() id: string;
    /**
     * Se o valor é obrigatório
     */
    @Input() required: any;
    /**
     * Se deve desabilitar o input
     */
    @Input() disabled: any;

    /** Se deve filtrar somente os grupos ativos */
    @Input() somenteAtivos = false;
    /** Se deve considerar Análise de Mercado */
    @Input() considerarClienteAnaliseMercado: boolean = null;
    /** Se deve considerar Meta */
    @Input() considerarMeta: boolean = null;

    @ViewChild('select') select: ElementRef;

    propagateChange: any = () => {};

    constructor(private messageService: MessageService,
                private grupoClassificacaoCrudHttpService: GrupoClassificacaoCrudHttpService,
                private grupoClassificacaoClassificacaoHttpService: GrupoClassificacaoClassificacaoHttpService) { }

    ngOnInit() {
        this.search();
    }

    /** Verifica se o grupo da classificação do item esta inativo */
    isSituacaoInativo(situacao: number): boolean {
        return isSituacaoInativo(situacao);
    }

    private createFilter(): GrupoClassificacaoFilter {
        const filter = new GrupoClassificacaoFilter();
        // Somente ativas
        if (this.somenteAtivos) {
            filter.situacao = grupoClassificacaoSituacaoAtivo.id;
        }
        // Considerar Cliente Análise Mercado
        if (this.considerarClienteAnaliseMercado != null && this.considerarClienteAnaliseMercado !== undefined) {
            filter.considerarClienteAnaliseMercado = this.considerarClienteAnaliseMercado;
        }
        // Considerar Meta
        if (this.considerarMeta != null && this.considerarMeta !== undefined) {
            filter.considerarMeta = this.considerarMeta;
        }

        return filter;
    }

    /** Pesquisa os grupos das classificações pelo grupo */
    private search() {
        this.grupos = [];

        const filter = this.createFilter();
        this.grupoClassificacaoCrudHttpService.searchWithFilter(filter)
            .pipe(
                take(1)
            )
            .subscribe(
                grupos => this.grupos = grupos,
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar os grupos de segmentos', error)
            );
    }

    /** Ao alterar o grupo da classificação */
    onChange(idGrupoClassificacao: number) {
        this.ngModel = idGrupoClassificacao;
        this.ngModelChange.emit(this.ngModel);

        this.grupoClassificacao = this.grupos?.find(grupoFilter => grupoFilter.id === idGrupoClassificacao);
        this.grupoClassificacaoChange.emit(this.grupoClassificacao);

        // Pesquisando as classificação do grupo selecionado
        if (this.ngModel) {
            this.searchClassificacoes();
        } else {
            this.classificacoesChange.emit([]);
        }
    }

    /** Pesquisa as classificações do grupo */
    private searchClassificacoes() {
        this.grupoClassificacaoClassificacaoHttpService.search(this.ngModel)
            .pipe(
                take(1)
            )
            .subscribe(
                classificacoes => this.classificacoesChange.emit(classificacoes),
                (error: ApiError) => {
                    this.messageService.error(error.message, 'Erro ao pesquisar os segmentos do grupo selecionado', error);
                    this.classificacoesChange.emit([]);
                }
            );
    }

    /** Seta o focus no select */
    setFocus() {
        jQuery(this.select?.nativeElement).trigger('focus');
    }

    writeValue(value: number) {}

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}
}
